import { httpRawClient } from '@core/http-client'

export const getAudioPeaks = (peaksUrl: string, signal?: AbortSignal) => {
    return httpRawClient
        .get(peaksUrl, {
            signal,
        })
        .json<number[]>()
}
